import Vue from 'vue'
import Swiper from '@/components/Molecules/Swiper/Swiper.vue'
import SwiperSlide from '@/components/Molecules/SwiperSlide/SwiperSlide.vue'

Vue.component('Swiper', Swiper)
Vue.component('SwiperSlide', SwiperSlide)
